import { platformSettingActions } from '../../../controller';
import { SocketTypeEnums } from '../../../../lib/enums';

const {
	PLATFORM_STATUS_EVENT_UPDATED,
	PLATFORM_SETTING_MAINTENANCE_EVENT_UPDATED,
} = SocketTypeEnums;
const {
	updatePlatformStatusAction,
	updatePlatformSettingMaintenanceAction,
} = platformSettingActions;

export function updatedPlatformStatusEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(PLATFORM_STATUS_EVENT_UPDATED, ({ data: { platform } }) => {
		dispatch(updatePlatformStatusAction(platform));
	});
}

export function updatedPlatformSettingMaintenanceEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(PLATFORM_SETTING_MAINTENANCE_EVENT_UPDATED, ({ data: { maintenance } }) => {
		dispatch(updatePlatformSettingMaintenanceAction(maintenance));
	});
}
